import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ReactTable from "components/lib/Global/ReactTable";
import { getMaintainYourCompanyReviewStatus } from "config/documentData";
import { getEmployeeAsync } from "state/slices/employee";

const TypeOfChange = ({ uniqueTransactionsArray, actionType }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    if (params.companyId) {
      dispatch(getEmployeeAsync({ companyId: params.companyId }));
    }
  }, [dispatch, params.companyId]);

  const columns = [
    {
      Header: "Batch No.",
      accessor: "BatchNo",
      Cell: ({ row }) => row?.original?.batchNo || "-",
    },
    {
      Header: "Application Type",
      accessor: "applicationType",

      Cell: ({ row }) => {
        return row.original?.applicationType || "Incorporation";
      },
    },
    {
      Header: "Change Type",
      accessor: "changeType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return capitalize(original?.changeType) || original?.type || "-";
      },
    },
    {
      Header: "Tnx No.",
      accessor: "TnxNo",
      Cell: ({ row: { original } }) => {
        return original?.trxRef || original?.registrationNumber || "-";
      },
    },

    {
      Header: "Action",
      Cell: ({ row }) => {
        const prefix = row.isExpanded
          ? "Close"
          : actionType === "incorporation-view" ||
            actionType === "manage-transaction-view"
          ? "View"
          : actionType.charAt(0).toUpperCase() + actionType.slice(1);
        return prefix;
      },
    },
  ];

  return (
    <>
      <div className="mt-6 w-full bg-white shadow overflow-x-auto">
        <ReactTable
          columns={columns}
          data={uniqueTransactionsArray || []}
          dataRowCellStyle="pl-4 leading-snug py-2"
          // renderRowSubComponent={renderRowSubComponent}
          paginate={true}
          totalRows={10}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </>
  );
};

export default TypeOfChange;
